export default __webpack_public_path__ + "static/media/element_44.8025097c.webp";